// v2/components/Footer.js — site geneli alt bilgi
import React, { useState, useCallback } from 'react';
import {
  MapPin, Phone, Mail, Send, CheckCircle2, ShieldCheck, Clock,
} from 'lucide-react';
import styles from './Footer.module.css';

const QUICK_LINKS = [
  { label: 'Hakkımızda',   href: 'https://yenib2b.asotomotiv.net/hakkimizda' },
  { label: 'Hizmetlerimiz', href: 'https://yenib2b.asotomotiv.net/hizmetler' },
  { label: 'Ürünlerimiz',  href: 'https://yenib2b.asotomotiv.net/urunler' },
  { label: 'Kariyer',      href: 'https://yenib2b.asotomotiv.net/kariyer' },
  { label: 'Blog',         href: 'https://yenib2b.asotomotiv.net/blog' },
];

const ADDRESS = 'Küsget San. Sit. Anafartalar Bulv. As Otomotiv Plaza No:1 Şehitkamil / GAZİANTEP';
const PHONE = '+90 (342) 235 00 24';
const PHONE_HREF = 'tel:+903422350024';
const EMAIL = 'info@as-otomotiv.com.tr';

export default function Footer({ version = 'v2.0' }) {
  const [mail, setMail] = useState('');
  const [sent, setSent] = useState(false);

  const subscribe = useCallback(() => {
    const v = mail.trim();
    if (!v || !v.includes('@')) return;
    // TODO: API baglaninca abonelik istegi buraya
    setSent(true);
    setMail('');
    setTimeout(() => setSent(false), 3200);
  }, [mail]);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>

        {/* marka */}
        <div className={styles.brandBlock}>
          <div className={styles.brandRow}>
            <span className={styles.logoCard}>
              <img className={styles.asLogo} src="/asotomotivlogo_web.png" alt="AS Otomotiv" />
            </span>
          </div>
          <p className={styles.brandText}>
            Otomotiv yedek parça tedarikinde bayi çözümleri. Gaziantep ve İstanbul
            depolarımızdan hızlı sevkiyat, geniş Bosch ürün gamı.
          </p>
          <div className={styles.badgeRow}>
            <span className={styles.badge}><ShieldCheck size={11} /> Orijinal Ürün</span>
            <span className={styles.badge}><Clock size={11} /> Hafta içi 08:30 – 18:30</span>
          </div>
        </div>

        {/* hizli linkler */}
        <div>
          <h3 className={styles.colTitle}>Hızlı Linkler</h3>
          <ul className={styles.linkList}>
            {QUICK_LINKS.map((l) => (
              <li key={l.href}>
                <a className={styles.link} href={l.href}>
                  <span className={styles.linkDot} />{l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* iletisim */}
        <div>
          <h3 className={styles.colTitle}>İletişim</h3>
          <div className={styles.contactList}>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><MapPin size={13} /></span>
              <span className={styles.contactText}>{ADDRESS}</span>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><Phone size={13} /></span>
              <a className={styles.contactText} href={PHONE_HREF}>{PHONE}</a>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}><Mail size={13} /></span>
              <a className={styles.contactText} href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </div>
          </div>
        </div>

        {/* e-bulten */}
        <div>
          <h3 className={styles.colTitle}>E-Bülten</h3>
          <p className={styles.newsText}>
            Yeni ürünler, kampanyalar ve fiyat güncellemelerinden ilk siz haberdar olun.
          </p>
          {sent ? (
            <div className={styles.newsOk}>
              <CheckCircle2 size={15} /> Aboneliğiniz alındı, teşekkürler.
            </div>
          ) : (
            <div className={styles.newsForm}>
              <input
                className={styles.newsInput} type="email" value={mail}
                onChange={(e) => setMail(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') subscribe(); }}
                placeholder="E-posta adresiniz"
                aria-label="E-bülten için e-posta adresi"
              />
              <button type="button" className={styles.newsBtn} onClick={subscribe}>
                <Send size={13} /> Abone Ol
              </button>
            </div>
          )}
        </div>

      </div>

      {/* alt serit */}
      <div className={styles.bottom}>
        <div className={styles.bottomInner}>
          <span>© {new Date().getFullYear()} EforInnovate. Tüm hakları saklıdır.</span>
          <span className={styles.bottomSpacer} />
          <span className={styles.madeBy}>
            Bu site
            <a className={styles.efLink} href="tel:+905322559950" title="EforInnovate · +90 532 255 99 50">
              <img className={styles.efLogo} src="/eforinnovate_siyaharka_web.png" alt="EforInnovate" />
            </a>
            tarafından yapılmıştır ·
            <a className={styles.bottomLink} href="tel:+905322559950">+90 532 255 99 50</a>
          </span>
          <span className={styles.verChip}>{version}</span>
        </div>
      </div>
    </footer>
  );
}
